import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map, share } from "rxjs/operators";

import { InstallationHttpClient, ParametreForAktuelleInstallation } from "@e-forsyning/common/http";

import { IEjendomsoplysning } from "./ejendomsoplysning.model";

@Injectable({ providedIn: "root" })
export class EjendomsoplysningerRepository {
    constructor(private readonly http: InstallationHttpClient) {}

    public hentEjendomsoplysninger(): Observable<IEjendomsoplysning[]> {
        return this.http.get("api/getallejendomsfaktor", ParametreForAktuelleInstallation.true).pipe(
            share(),
            map((ejendomsoplysningerFof: any) => this.mapTo(ejendomsoplysningerFof))
        );
    }

    private mapTo(ejendomsoplysningerFof: any): IEjendomsoplysning[] {
        const ejendomsoplysninger: IEjendomsoplysning[] = [];

        for (const item of ejendomsoplysningerFof.efaktors) {
            const oplysning = {
                navn: item.faktorTekst,
                enhed: item.enhed,
                vaerdi: item.vaerdi,
                kommentar: item.beskrivelse
            };

            ejendomsoplysninger.push(oplysning);
        }
        return ejendomsoplysninger;
    }
}
